<template>
  <div class="logo" :class="sizeClass">
    <img :src="logoFile" :class="[sizeClass, imgClass]" :alt="altFinal" :style="style" />
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  name: "Logo",
  props: {
    logo: {
      type: String,
    },
    size: {
      type: Number,
      default: 18,
    },
    imgClass: {
      type: String,
    },
    alt: String,
    rotate: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const logoList = {
      "american express": require("@/assets/amex.png"),
      "location-aws": require("@/assets/location-aws.png"),
      "location-au": require("@/assets/location-au.svg"),
      "location-nl": require("@/assets/location-nl.svg"),
      "location-uk": require("@/assets/location-uk.svg"),
      "location-us": require("@/assets/location-us.svg"),
      "2fa": require("@/assets/logo-2fa.png"),
      bigcommerce: require("@/assets/logo-bigcommerce.png"),
      "business-rocket-initials": require("@/assets/business-rocket-initials.png"),
      "business-rocket-logo": require("@/assets/business-rocket-logo.svg"),
      centos: require("@/assets/logo-centos.png"),
      craftcms: require("@/assets/logo-craftcms.png"),
      discover: require("@/assets/discover.png"),
      drupal: require("@/assets/logo-drupal.png"),
      elasticsearch: require("@/assets/logo-elasticsearch.png"),
      expressionengine: require("@/assets/logo-expressionengine.png"),
      fedora: require("@/assets/logo-fedora.png"),
      generic: require("@/assets/logo-generic.svg"),
      godaddy: require("@/assets/godaddy-logo.png"),
      happiness: require("@/assets/happiness.svg"),
      magento: require("@/assets/magento.svg"),
      mastercard: require("@/assets/mastercard.png"),
      maestro: require("@/assets/maestro.png"),
      nexcess: require("@/assets/nexcess-logo-square-200px.png"),
      nginx: require("@/assets/logo-nginx.png"),
      orocrm: require("@/assets/logo-orocrm.png"),
      paypal: require("@/assets/pay-pal.svg"),
      "paypal-card": require("@/assets/paypal-card.jpeg"),
      php: require("@/assets/logo-php.png"),
      rabbitmq: require("@/assets/logo-rabbitmq.png"),
      redis: require("@/assets/logo-redis.png"),
      rocky: require("@/assets/logo-rocky.svg"),
      sadness: require("@/assets/sadness.svg"),
      "safe-harbor-bad-bot": require("@/assets/safe-harbor-bad-bot.svg"),
      "safe-harbor-firewall": require("@/assets/safe-harbor-firewall.svg"),
      "safe-harbor-ip": require("@/assets/safe-harbor-ip.svg"),
      shopify: require("@/assets/shopify-logo.png"),
      solr: require("@/assets/logo-solr.png"),
      squarespace: require("@/assets/squarespace-logo.png"),
      sylius: require("@/assets/logo-sylius.png"),
      storebuilder: require("@/assets/storebuilder-platform-logo.svg"),
      ubuntu: require("@/assets/logo-ubuntu.png"),
      varnish: require("@/assets/logo-varnish.png"),
      visa: require("@/assets/visa.png"),
      wix: require("@/assets/wix-logo.png"),
      woocommerce: require("@/assets/woocommerce.svg"),
      wordpress: require("@/assets/wordpress.svg"),
      oops: require("@/assets/oops.svg"),
    };

    const logoFile = computed(() => {
      if (logoList?.[props.logo]) {
        return logoList[props.logo];
      }

      return null;
    });

    const sizeClass = computed(() => {
      return `size-${props.size}`;
    });

    const altFinal = computed(() => {
      return props.alt || props.logo;
    });

    const style = computed(() => {
      return { transform: `rotate(${props.rotate}deg)` };
    });

    return {
      logoFile,
      sizeClass,
      altFinal,
      style,
    };
  },
};
</script>

<style lang="scss" scoped>
.logo {
  position: relative;

  @for $i from 1 through 200 {
    &.size-#{$i} {
      width: #{$i}px;
      height: auto;
    }
  }

  img {
    transition: transform 0.5s ease;
    @for $i from 1 through 200 {
      &.size-#{$i} {
        width: #{$i}px;
        height: auto;
      }
    }
  }
}
</style>
